import React, { FC } from 'react';
import { getPercentPieChartConfig } from '../../getPieChartConfig';
import { ChartPercentLegend } from '../../legend/ChartLegend';
import { LazyReactChart } from '../../LazyReactChart';
import {
  EntityChartBlock,
  EntityChartItem,
} from '../../components/EntityChartComponents';

type Props = {
  sizesData: Array<number> | undefined | null;
  sizesLabels: Array<string> | undefined | null;
};

export const CompanySizeTypologiesChart: FC<Props> = ({
  sizesData,
  sizesLabels,
}) => {
  const sizesBaseH = 218;

  return (
    <EntityChartBlock>
      <EntityChartItem>
        {sizesData && sizesLabels && (
          <LazyReactChart
            config={getPercentPieChartConfig({
              data: sizesData,
              labels: sizesLabels,
              baseH: sizesBaseH,
            })}
          />
        )}
      </EntityChartItem>
      {sizesData && sizesLabels && (
        <ChartPercentLegend
          data={sizesData}
          labels={sizesLabels}
          baseH={sizesBaseH}
        />
      )}
    </EntityChartBlock>
  );
};
